if(typeof(widgets) === 'undefined'){
	var widgets = {};
}
  

widgets['products'] = {

	config:{

	},         
	init:function(){
		this.initFilters();		
	},

	initFilters : function(){

		
		$( '.product-filters select.select2-filters' ).each( function( ) {
		        var data = $( this ).data( );
		        var _this = $( this );
		        var options = {
		        	 dropdownParent: _this.closest('div'),
		            templateSelection: function (data) {
		                if (!data.element) {
		                    return data.text;
		                }
		                var $element = $(data.element);

		                var $wrapper = $('<span></span>');
		                $wrapper.addClass($element[0].className);

		                $wrapper.html(data.text);

		                return $wrapper;
		            },
		            escapeMarkup: function(markup) {
		                return markup;
		            },
		            templateResult: function (data) {
		                // We only really care if there is an element to pull classes from
		                if (!data.element) {
		                    return data.text;
		                }

		                var $element = $(data.element);

		                var $wrapper = $('<span></span>');
		                $wrapper.addClass($element[0].className);

		                $wrapper.html(data.text);

		                return $wrapper;
		            }
		        };

		       

		        if ( data.ajax ) {
		            options = $.extend( false, options, {
		                placeholder: data.placeholder,
		                allowClear: data.allowClear || false,
		                ajax: {
		                    url:  'api/' + data.ajax,
		                    dataType: 'json',
		                    delay: 250,
		                    data: function( params ) {

		                        var search_for = typeof( params.term ) !== 'undefined' ? params.term : '';
		                        return {
		                            q: data.search + '=@' + search_for,
		                            page: params.page
		                        };
		                    }, 
		                    processResults: function( res, params ) {
		                     
		                        params.page = params.page || 1;
		                        var value_field = data.value || 'id';
		                        var label_field = data.label || data.search;
		                        return {
		                            results: $.map( res.data, function( item ) {
		                                return {
		                                    all_data: item,
		                                    text: item[ label_field ],
		                                    id: item[ value_field ]
		                                }
		                            } ),
		                            pagination: {
		                                more: ( params.page * 30 ) < data.total_count
		                            }
		                        };
		                    },
		                    cache: true
		                },
		                minimumInputLength: 0
		            } );
		        }           

		        if(data.disable_search){
		            options = $.extend( false, options, {
		                minimumResultsForSearch: -1
		             } );
		        }

		        if(data.allowclear){
		            options = $.extend( false, options, {
		                allowClear: data.allowclear || false,
		             } );
		        }

		        var  multiple_single_selection_value=null; 
		        if(data.multiple_single_selection){
		            multiple_single_selection_value = _this.val();
		        }
		     
		         if ( data.link_results_child ) {
			           

			     }
		        

		        _this.select2(options).on('select2:open', function () {
		            $(this).closest('.form-group').addClass('filled');
		            $('.select2-dropdown').closest('.select2-container').addClass('z-index-dropdown');
		        }).on('select2:selecting', function (e) {
		           if(data.multiple_single_selection){
		                multiple_single_selection_value =  typeof(e.params.args.data.id)!=='undefined' ? e.params.args.data.id : null;
		       
		    	   }
		        }).on('select2:clear ', function (e) {

		        	$(this).closest('.partial').data(_this.attr('name'),'');
		           
		        }).on('change', function (e) {
		        	
		            if(data.link_results_child){
		            	if( $(this).val()!==null ||  $(this).val()=='' ){
		            		$input_name="";
		            		$(data.link_results_child).find('.option').each(function() {
				             	 $(this).find('input').prop('checked', false);
				             	 $input_name=$(this).find('input').attr('name');
				             });
				           	 $(this).closest('.partial').data($input_name,'');
		            	}
			             
			        }

		            widgets['products'].applyFilters();

		        }).on('select2:close', function () {
		            if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
		                $(this).closest('.form-group').removeClass('filled');
		            }   
		            $('.select2-dropdown').closest('.select2-container').removeClass('z-index-dropdown'); 
		             
				        
				            

		        }); 



		    }); 

		$('.filter-attribute input[type="checkbox"]').change(function(){
			widgets['products'].applyFilters();
		});
	},
	sorting: function($this,$sorting){
		var theFilters = $('.filters-form');
		var $thePartial = $('.products-list-partial.partial').first();
		$thePartial.attr('data-sort',$sorting);
		

		$('.sortingDropdown a').removeClass('active');
		$this.addClass('active');
		$('.sortingDropdown').addClass('disabled');
		theFilters.addClass('disabled');
		load_partial($thePartial,function(){
			theFilters.removeClass('disabled');
			$('.sortingDropdown').removeClass('disabled');
		});	
		url = updateURLParameter( window.location.href, 'sort', $sorting);						
		history.pushState({}, null, url);
	},

	applyFilters : function (){
		var theFilters = $('.filters-form');
		var $thePartial = $('.products-list-partial.partial').first();
		$('body').removeClass('product-filter-visible');
          		var options = [];
                var values = [];
                var option_name;
                $(theFilters).find('input[type="checkbox"]').each(function () {

                      option_name = $(this).attr('name');

                         
                        if (options.indexOf(option_name) == -1) {
                            options.push(option_name);
                        }
                        if (typeof (values[option_name]) == 'undefined' || values[option_name] == '') {
                            values[option_name] = [];
                        }


                        if ($(this).is(':checked')) {
                            if (values[option_name].indexOf($(this).val()) == -1) {
                                values[option_name].push($(this).val());
                            }
                        }/* else {
                            if (Array.isArray(values[option_name])) {
                                var val = $(this).val();
                                values[option_name] = values[option_name].filter(function (v) {
                                    return v != val;
                                });
                            }
                        }*/

                        
 
                });

                $(theFilters).find('select').each(function () {

                      option_name = $(this).attr('name');
                      var filter_val;
                      if(Array.isArray($(this).val())  ){
                      	 filter_val= JSON.stringify($(this).val());
                      }else{
                      	filter_val = $(this).val();
                      }
                        	

                        if (options.indexOf(option_name) == -1) {
                            options.push(option_name);
                        }


                        if (typeof (values[option_name]) == 'undefined' || values[option_name] == '') {
                            values[option_name] = [];
                        }

                         if (values[option_name].indexOf(filter_val) == -1) {
                            values[option_name].push(filter_val );
                        }

 
                });
                if(values[option_name].length == 1){
                    values[option_name] = values[option_name][0];
                }
                if(theFilters.find('input[type="radio"]').length > 0){
                    theFilters.find('input[type="radio"]').each(function () {
                        option_name = $(this).attr('name');
                      if (options.indexOf(option_name) == -1) {
                          options.push(option_name);
                      }
                      if (typeof (values[option_name]) == 'undefined' || values[option_name] == '') {
                          values[option_name] = '';
                      }
                      if ($(this).is(':checked')) {
                          values[option_name] = $(this).val();
                      }
                  });
  
                  if(values[option_name].length == 1){
                      values[option_name] = values[option_name][0];
                  }
                }
                

           
            for (var i in options) {
                if (typeof (values[options[i]]) === 'undefined') {
                    values[options[i]] = '';
                }
            }

           $($thePartial).data(values);
        
            $($thePartial).data('page',1);

            $values = $($thePartial).data();

            deepLinking($values);

            load_partial($($thePartial));

       
	},

	removeFilter: function ($this){
		var $id = $($this).data('value');
        var $name = $($this).data('name');
        var $type = $($this).data('type');

        if($type=='select'){
        		var select_vals = $('.filters-form select[name="'+$name+'"]').val();
        		 
        	if (Array.isArray(select_vals) ) {
        		 $('.filters-form select[name="'+$name+'"] option[value="'+$id+'"]').prop('selected', false);
        		 $('.filters-form select[name="'+$name+'"]').trigger('change.select2'); 
              
            }else if (Array.isArray(select_vals.split(',')) ) {
            	 $('.filters-form select[name="'+$name+'"] option[value="'+$id+'"]').prop('selected', false);
        		 $('.filters-form select[name="'+$name+'"]').trigger('change.select2'); 
            	
            }else{
            	$('.filters-form select[name="'+$name+'"]').val(null).trigger('change.select2'); 
            }
        }else if($type=='checkbox'){
    	  	$('.filters-form input[name="'+$name+'"][value="'+$id+'"]').prop("checked", false);
        }

         widgets['products'].applyFilters();
        
        $this.remove();
	},
	removeFilters: function (  ){		
		var theFilters = $('.filters-form');
		var $thePartial = $('.products-list-partial.partial').first();
		$('.filter-tag').each(function(){
			$this = $(this);			
			var $filter = $this.data('code');
			var $ranged = $this.data('isarray');

			$('.filter-attribute[data-code="'+$filter+'"]').removeClass('selected');

			$this.remove();
			if($ranged){	
				url = updateURLParameter( window.location.href, 'min_'+$filter,'');						
				url = updateURLParameter( url, 'max_'+$filter,'');						
				history.pushState({}, null, url);
			}else{			
				url = updateURLParameter( window.location.href, $filter,'');						
				history.pushState({}, null, url);
				$thePartial.removeAttr('data-'+$filter);			
			}
		});		
		theFilters.addClass('disabled');
		load_partial($thePartial,function(){
			theFilters.removeClass('disabled');
		});
	},

	showCartAddedBanner: function (message, type) {
		var bannerId = 'cart-action-banner';
		var timeoutMs = 5000;
		var statusType = type === 'error' ? 'error' : 'success';
		var bgColor = statusType === 'error' ? '#b42318' : '#0b67c2';
		var icon = statusType === 'error'
			? '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 8v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="16" r="1" fill="currentColor"/><path d="M10.29 3.86 1.82 18A2 2 0 0 0 3.53 21h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>'
			: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7 9 18l-5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		var $existing = $('#' + bannerId);
		if ($existing.length) $existing.remove();

		var $banner = $(
			'<div id="' + bannerId + '" role="status" aria-live="polite" style="position:fixed;top:12px;left:50%;transform:translateX(-50%);z-index:20000;max-width:1100px;width:calc(100% - 24px);background:' + bgColor + ';color:#fff;border-radius:var(--radius-md);box-shadow:0 6px 20px rgba(0,0,0,.25);padding:10px 14px;display:flex;align-items:flex-start;gap:10px;">' +
				'<span style="display:inline-flex;line-height:1;margin-top:2px;">' + icon + '</span>' +
				'<div style="flex:1;font-size:13px;line-height:1.35;font-weight:500;">' +  localeMsg('productAddedToCart') + '</div>' +
				'<button type="button" aria-label="' + localeMsg('closeNotification') + '" style="appearance:none;border:0;background:transparent;color:#fff;font-size:20px;line-height:1;cursor:pointer;padding:0 2px;">&times;</button>' +
			'</div>'
		);

		$banner.find('button').on('click', function () {
			$banner.fadeOut(180, function () { $banner.remove(); });
		});

		$('body').append($banner);
		setTimeout(function () {
			if ($banner.is(':visible')) {
				$banner.fadeOut(220, function () { $banner.remove(); });
			}
		}, timeoutMs);
	},

	addToCart: function (productId, options) {
		options = options || {};
		function parseMoney(v) {
			if (v == null) return undefined;
			if (typeof v === 'number') return isFinite(v) ? v : undefined;
			var s = String(v).replace(/[^\d.,-]/g, '').replace(',', '.');
			var n = parseFloat(s);
			return isFinite(n) ? n : undefined;
		}
		var quantity = 1;
		if (options.participants && typeof options.participants === 'object') {
			quantity = 0;
			for (var k in options.participants) {
				if (options.participants[k].quantity) {
					quantity += parseInt(options.participants[k].quantity, 10) || 0;
				}
			}
		}
		if (quantity < 1) quantity = 1;
		var payload = {
			product_id: productId,
			quantity: quantity,
			'data[option_id]': options.option_id || '',
			'data[date]': options.date || '',
			'data[time]': options.time || '',
			'data[rate_id]': options.rate_id || '',
			'data[participants]': typeof options.participants === 'object' ? JSON.stringify(options.participants || {}) : (options.participants || '{}')
		};
		if (options.rate) payload['data[rate]'] = options.rate;
		// Price is always calculated server-side from Bokun quote; do not send total_price/display_total_price from JS
		if (options.no_refund_selected != null) payload['data[no_refund_selected]'] = options.no_refund_selected ? 1 : 0;
		if (options.no_refund_discount_percentage != null && options.no_refund_discount_percentage !== '') payload['data[no_refund_discount_percentage]'] = options.no_refund_discount_percentage;
		if (options.no_refund_discount_amount != null && options.no_refund_discount_amount !== '') payload['data[no_refund_discount_amount]'] = options.no_refund_discount_amount;
		if (options.language != null && options.language !== '') payload['data[language]'] = options.language;
		if (options.language_display != null && options.language_display !== '') payload['data[language_display]'] = options.language_display;
		if (options.pickup_place_id != null && options.pickup_place_id !== '') payload['data[pickup_place_id]'] = options.pickup_place_id;
		if (options.pickup_point != null && options.pickup_point !== '') payload['data[pickup_point]'] = options.pickup_point;
		if (options.pickup_lat != null && options.pickup_lat !== '') payload['data[pickup_lat]'] = options.pickup_lat;
		if (options.pickup_lon != null && options.pickup_lon !== '') payload['data[pickup_lon]'] = options.pickup_lon;
		if (options.pickup_time != null && options.pickup_time !== '') payload['data[pickup_time]'] = options.pickup_time;
		if (options.dropoff_place_id != null && options.dropoff_place_id !== '') payload['data[dropoff_place_id]'] = options.dropoff_place_id;
		if (options.dropoff_point != null && options.dropoff_point !== '') payload['data[dropoff_point]'] = options.dropoff_point;
		if (options.dropoff_lat != null && options.dropoff_lat !== '') payload['data[dropoff_lat]'] = options.dropoff_lat;
		if (options.dropoff_lon != null && options.dropoff_lon !== '') payload['data[dropoff_lon]'] = options.dropoff_lon;
		if (options.booking_questions != null && Array.isArray(options.booking_questions) && options.booking_questions.length > 0) {
			payload['data[booking_questions]'] = JSON.stringify(options.booking_questions);
		}
		if (options.participant_booking_data != null && Array.isArray(options.participant_booking_data) && options.participant_booking_data.length > 0) {
			payload['data[participant_booking_data]'] = JSON.stringify(options.participant_booking_data);
		}
		if (options.min_per_booking != null && options.min_per_booking !== '') payload['data[min_per_booking]'] = options.min_per_booking;
		if (options.max_per_booking != null && options.max_per_booking !== '') payload['data[max_per_booking]'] = options.max_per_booking;
		if (options.start_time_id != null && options.start_time_id !== '' && /^\d+$/.test(String(options.start_time_id))) {
			payload['data[start_time_id]'] = options.start_time_id;
		}
		var redirectToCheckout = options.redirectToCheckout === true;
		if (typeof showPartialPreloader === 'function') {
			showPartialPreloader();
		}
		$.ajax({
			type: 'POST',
			url: '/api/orders',
			data: payload,
			success: function (data) {
				if (typeof hidePartialPreloader === 'function') {
					hidePartialPreloader();
				}
				// Centralized tracking (GA/FB/TikTok) via GlobalTracking.*
				try {
					if (typeof GlobalTracking !== 'undefined' && GlobalTracking && typeof GlobalTracking.add_to_cart === 'function') {
						var currency = options.currency || (data && data.currency) || 'EUR';
						var price = parseMoney(options.total_price) ?? parseMoney(options.totalPrice) ?? parseMoney(options.display_total_price) ?? parseMoney(options.price) ?? parseMoney(options.unit_price);
						// Fallback to the server response so the GA4 value is not empty when JS lacks a price.
						if (price === undefined || price === null || (typeof price === 'number' && isNaN(price))) {
							price = parseMoney(data && (data.price || data.line_price || data.unit_price));
						}
						var name = options.item_name || options.product_name || options.title || (window.bookingSidebarConfig && window.bookingSidebarConfig.productTitle) || '';
						var variant = options.item_variant || options.rate || '';
						GlobalTracking.add_to_cart(currency, price, productId, name, variant);
					}
				} catch (e) {}

				widgets['products'].showCartAddedBanner( localeMsg('productAddedToCart'), 'success');
				var total = (data.totals && data.totals.products != null) ? data.totals.products : 0;
				if (typeof cart !== 'undefined' && typeof cart.refresh_totals === 'function') {
					cart.refresh_totals(total);
				} else {
					// Product page: cart.js not loaded — refresh header.cart-total and counter manually
					if (typeof load_partial === 'function') {
						$('[data-refresh-after-cart-change]').each(function () {
							load_partial($(this));
						});
					}
					if (total > 0) {
						$('#cart_counter').text(total);
						$('#cart_counter').closest('a').addClass('filled');
					} else {
						$('#cart_counter').text(0);
						$('#cart_counter').closest('a').removeClass('filled');
					}
				}
				if (redirectToCheckout) {
					var checkoutUrl = BASE_URL + "/" + CURRENT_LANGUAGE + "/checkout";
					if (data.redirect) checkoutUrl = data.redirect;
					setTimeout(function() {
						window.location = checkoutUrl ;
					}, 3000);
				}
			},
			error: function (xhr) {
				if (typeof hidePartialPreloader === 'function') {
					hidePartialPreloader();
				}
				var msg = (xhr.responseJSON && xhr.responseJSON.error) ? xhr.responseJSON.error : localeMsg('unableToAddToCart');
				if (typeof actionResponseModal === 'function') {
					actionResponseModal(msg, 'error');
				} else {
					alert(msg);
				}
			}
		});
	},

	addToWishlist: function (productId) {
		// Not logged in: open sign-in modal
		if (typeof USER_ID === 'undefined' || USER_ID === '0' || USER_ID === 0) {
			if (typeof openPartialModal === 'function') {
				openPartialModal(null, { partial: 'account.partials.signup', view: 'login' }, null);
			}
			return;
		}
		// Logged in: add to favorites (wishlist) via API
		$.ajax({
			type: 'POST',
			url: '/api/favorites',
			data: {
				item_id: productId,
				item_type: 'product'
			},
			success: function (data) {
				if (typeof actionResponseModal === 'function') {
					actionResponseModal(data.message || localeMsg('addedToWishlist'), 'success');
				}
				// Optional: toggle wishlist button state if present
				$('[data-wishlist-product-id="' + productId + '"]').addClass('saved');
			},
			error: function (xhr) {
				if (xhr.status === 401 && typeof openPartialModal === 'function') {
					openPartialModal(null, { partial: 'account.partials.signup', view: 'login' }, null);
				} else if (typeof actionResponseModal === 'function') {
					actionResponseModal((xhr.responseJSON && xhr.responseJSON.error) ? xhr.responseJSON.error : localeMsg('unableToAddToWishlist'), 'error');
				}
			}
		});
	},

	
	applyWidgetFilters : function ($this){
			var theFilters = $this.closest('form');
      		var options = [];
            var values = [];
            var option_name;
            $(theFilters).find('input[type="checkbox"]').each(function () {

                  option_name = $(this).attr('name');

                     
                    if (options.indexOf(option_name) == -1) {
                        options.push(option_name);
                    }
                    if (typeof (values[option_name]) == 'undefined' || values[option_name] == '') {
                        values[option_name] = [];
                    }


                    if ($(this).is(':checked')) {
                        if (values[option_name].indexOf($(this).val()) == -1) {
                            values[option_name].push($(this).val());
                        }
                    }/* else {
                        if (Array.isArray(values[option_name])) {
                            var val = $(this).val();
                            values[option_name] = values[option_name].filter(function (v) {
                                return v != val;
                            });
                        }
                    }*/

                    

            });

            $(theFilters).find('select').each(function () {

                  option_name = $(this).attr('name');
                  var filter_val;
                  if(Array.isArray($(this).val())  ){
                  	 filter_val= JSON.stringify($(this).val());
                  }else{
                  	filter_val = $(this).val();
                  }

                    if (options.indexOf(option_name) == -1) {
                        options.push(option_name);
                    }


                    if (typeof (values[option_name]) == 'undefined' || values[option_name] == '') {
                        values[option_name] = [];
                    }

                     if (values[option_name].indexOf(filter_val) == -1) {
                        values[option_name].push(filter_val );
                    }


            });
            if(values[option_name].length == 1){
                values[option_name] = values[option_name][0];
            }
            if(theFilters.find('input[type="radio"]').length > 0){
                theFilters.find('input[type="radio"]').each(function () {
                    option_name = $(this).attr('name');
                  if (options.indexOf(option_name) == -1) {
                      options.push(option_name);
                  }
                  if (typeof (values[option_name]) == 'undefined' || values[option_name] == '') {
                      values[option_name] = '';
                  }
                  if ($(this).is(':checked')) {
                      values[option_name] = $(this).val();
                  }
              });

              if(values[option_name].length == 1){
                  values[option_name] = values[option_name][0];
              }
            }
                

           
            for (var i in options) {
                if (typeof (values[options[i]]) === 'undefined') {
                    values[options[i]] = '';
                }
            }


             var _page = true;
			    var h = '?';
			    var del = '';
			    for ( var i in values ) {

			        if ( i == 'page' ) {
			            _page = false;
			        }
			        if ( values[ i ] == '' || i === 'partial' || i === 'current_url' ||
			            i === 'hide' || i === 'filter_id' || i === 'incrementing' || i === 'exists' || i === 'timestamps' ||
			            i === 'widgetconfig' || i === 'box_image_1' ||
			            i === 'box_image_2' || i === 'widgetConfig' || i === 'content_info' ||
			            i === 'page_position' || i === 'images_content_title' || i === 'content_title' || i === 'content_subtitle' ) {
			            continue;
			        }



			        h += del + i + '=' + values[ i ];
			        del = '&';
			    }

			    if ( _page ) {
			        h += '&page=1';
			    }


            window.location.href = $(theFilters).attr('action')+h;


       
	}

}

function URLToArray(url) {
    var request = {};
    var pairs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < pairs.length; i++) {
        if(!pairs[i])
            continue;
        var pair = pairs[i].split('=');
        request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
     }
     return request;
}


function updateURLParameter(url, param, paramVal){
    var url = new URL(url);
	var search_params = url.searchParams;
	if(paramVal!==''){
		search_params.set(param, paramVal);
	}else{
		search_params.delete(param);
	}	
	url.search = search_params.toString();
	return url.toString();	
}

